// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TrainerCard_wrapper__wTFXz","circle":"TrainerCard_circle__IKgzp","title":"TrainerCard_title__Hr850"};